setLiveAccessTrack